module.exports = __webpack_public_path__ + "static/media/perfect-fit.c46eddad.jpg";